"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _colors = require("HubStyleTokens/colors");

var renderAlert = function renderAlert(troubleshooting) {
  if (!troubleshooting) {
    return null;
  }

  return _react.default.createElement(_UIAlert.default, {
    className: "m-x-auto m-bottom-2 text-left",
    type: "info",
    style: {
      maxWidth: 600
    },
    titleText: _react.default.createElement(_FormattedMessage.default, {
      message: "troubleshoot.alertTitle"
    })
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "troubleshoot.alert"
  }));
};

var TroubleshootModeToggle = function TroubleshootModeToggle(_ref) {
  var compact = _ref.compact,
      troubleshooting = _ref.troubleshooting,
      toggleTroubleshootMode = _ref.toggleTroubleshootMode,
      fetchTroubleshootTimes = _ref.fetchTroubleshootTimes;
  (0, _react.useEffect)(function () {
    if (troubleshooting) {
      fetchTroubleshootTimes();
    }
  }, [fetchTroubleshootTimes, troubleshooting]);
  var troubleshootMessageKey = troubleshooting ? 'troubleshoot.exit_jsx' : 'troubleshoot.enter1_jsx';
  var classes = 'p-top-4 text-center' + (compact ? " p-bottom-4" : "");
  return _react.default.createElement("div", {
    className: classes,
    style: {
      background: _colors.GYPSUM
    }
  }, renderAlert(troubleshooting), _react.default.createElement(_FormattedJSXMessage.default, {
    message: troubleshootMessageKey,
    options: {
      onClick: function onClick() {
        return toggleTroubleshootMode(!troubleshooting);
      },
      use: 'link',
      'data-selenium-test': 'troubleshoot-button'
    },
    elements: {
      Button: _UIButton.default
    }
  }), !troubleshooting && _react.default.createElement("div", null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "troubleshoot.enter2"
  })));
};

TroubleshootModeToggle.propTypes = {
  troubleshooting: _propTypes.default.bool.isRequired,
  toggleTroubleshootMode: _propTypes.default.func.isRequired,
  fetchTroubleshootTimes: _propTypes.default.func.isRequired,
  compact: _propTypes.default.bool.isRequired
};
var _default = TroubleshootModeToggle;
exports.default = _default;
module.exports = exports.default;